import { useRef } from 'react'

import cn from 'clsx'

import { useAppDispatch, useAppSelector } from '@App/hooks'
import { MODAL_TYPES } from '@App/redux/slices/modals/enums'
import { closeModal, isOpenCurrent, setModal } from '@App/redux/slices/modals/ModalSlice'
import { currentWallet } from '@App/redux/slices/user/selectors'
import { ArrowRight } from '@App/static/icons/AccountOrdersPageIcons'

import { SwitchAccountModal } from '../../../../modals/SwitchAccountModal'

import s from './AccountSelect.module.scss'

export const AccountSelect = () => {
  const wallet = useAppSelector(currentWallet)
  const dispatch = useAppDispatch()
  const isModalOpen = useAppSelector((state) => isOpenCurrent(state, MODAL_TYPES.SWITCH_ACCOUNT_MODAL))
  const hanldeOpenModal = () => {
    dispatch(
      setModal({
        modalType: MODAL_TYPES.SWITCH_ACCOUNT_MODAL,
      }),
    )
  }
  const handleCloseModal = () => {
    dispatch(closeModal())
  }

  return (
    <>
      <div className={cn(s.container, isModalOpen && s.active)} onClick={hanldeOpenModal}>
        {wallet?.name ? wallet.name : wallet?.currency_code}
        <ArrowRight className={s.icon} />
      </div>
      {isModalOpen && <SwitchAccountModal isOpen={isModalOpen} setIsOpen={handleCloseModal} />}
    </>
  )
}
